import { makeStyles } from "@material-ui/core/styles";
export const useAuthStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "100vh",
    justifyContent: "center",
    position: "relative",
    "&::before": {
      content: '""',
      position: "fixed",
      top: 0,
      left: 0,
      width: "40%",
      height: "40%",
      backgroundImage: `url(${process.env.PUBLIC_URL}/timantti.svg)`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top left",
      backgroundSize: "contain",
      opacity: 0.8,
      pointerEvents: "none",
      zIndex: 0,
    },
    "&::after": {
      content: '""',
      position: "fixed",
      bottom: 0,
      right: 0,
      width: "30%",
      height: "30%",
      backgroundImage: `url(${process.env.PUBLIC_URL}/timantti.svg)`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "bottom left",
      backgroundSize: "contain",
      transform: "scaleX(-1)",
      opacity: 0.8,
      pointerEvents: "none",
      zIndex: 0,
    },
    "& > *": {
      position: "relative",
      zIndex: 1,
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1, 0, 2),
  },
  loginLogo: {
    width: "200px",
    maxWidth: "100%",
  },
  logo: {
    width: "100%",
  },
  googlePlayBadge: {
    width: "6rem",
    height: "auto",
  },
}));
